import React from 'react';
import { useFormikContext } from 'formik';

import MarketTypeSearch from '@components/form/search/MarketTypeSearch';
import SociollaErrorMessage from './SociollaErrorMessage';

// eslint-disable-next-line react/prop-types
function SociollaMarketTypeSearch({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <MarketTypeSearch
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaMarketTypeSearch;
